var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.iconType},[_c('v-icon',_vm._g(_vm._b({attrs:{"color":_vm.color}},'v-icon',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }